// ── TM 직원 위젯 (Mini Row, 2026-06-06 정리) ────────────────────────────────
// 사용자 결정: 유지된 위젯은 my_daily_call_summary(Tier 1) 와 my_call_today.
// 제거: contracts_month/breakdown, recent_contracts_*, summary_*

import React from 'react';
import { Phone, FileSignature } from 'lucide-react';
import { MiniRow } from './MiniRow';

// ── 일일콜 N영업일 요약 (Tier 1) ────────────────────────────────────────────
// 큰 숫자 (text-2xl indigo) + "개" 작게 + 계약 작게. watermark: Phone.
export function MyDailyCallSummaryMini({ data, accentOverride, sortableId, onClick }) {
  if (!data) return <MiniRow icon={Phone} label="최근 10일" accent="indigo" accentOverride={accentOverride} size="S" loading sortableId={sortableId} watermarkIcon={Phone} onClick={onClick} />;
  if (!data.allowed) return <MiniRow icon={Phone} label="최근 10일" accent="indigo" accentOverride={accentOverride} size="S" denied sortableId={sortableId} watermarkIcon={Phone} />;
  const days = Number(data.days || 10);
  const meeting = Number(data.meetingCount || 0);
  const tickets = Number(data.contractTickets || 0);
  return (
    <MiniRow icon={Phone} label={`최근 ${days}일`} accent="indigo" accentOverride={accentOverride} width="wide" size="S" sortableId={sortableId} watermarkIcon={Phone} onClick={onClick}>
      <span className="flex flex-col items-end gap-1">
        <span className="inline-flex items-baseline gap-1">
          <span className="text-2xl font-black tabular-nums leading-none text-indigo-700 dark:text-indigo-300">{meeting}</span>
          <span className="text-[11px] font-semibold text-[var(--text-sub)]">개</span>
        </span>
        <span className="text-[11px] font-semibold text-emerald-700 dark:text-emerald-300 whitespace-nowrap tabular-nums">계약 {tickets}장</span>
      </span>
    </MiniRow>
  );
}

// ── 오늘 콜·미팅 ────────────────────────────────────────────────────────────
// 큰 숫자 (text-2xl indigo) + 미팅 작게. watermark: Phone.
export function MyCallTodayMini({ data, accentOverride, sortableId, onClick }) {
  if (!data) return <MiniRow icon={Phone} label="내 오늘 콜" accent="indigo" accentOverride={accentOverride} size="S" loading sortableId={sortableId} watermarkIcon={Phone} onClick={onClick} />;
  if (!data.allowed) return <MiniRow icon={Phone} label="내 오늘 콜" accent="indigo" accentOverride={accentOverride} size="S" denied sortableId={sortableId} watermarkIcon={Phone} />;
  return (
    <MiniRow icon={Phone} label="내 오늘 콜" accent="indigo" accentOverride={accentOverride} width="narrow" size="S" sortableId={sortableId} watermarkIcon={Phone} onClick={onClick}>
      <span className="flex flex-col items-end gap-1">
        <span className="inline-flex items-baseline gap-1">
          <span className="text-2xl font-black tabular-nums leading-none text-indigo-700 dark:text-indigo-300">{Number(data.calls || 0)}</span>
          <span className="text-[11px] font-semibold text-[var(--text-sub)]">콜</span>
        </span>
        <span className="text-[11px] font-semibold text-sky-700 dark:text-sky-300 whitespace-nowrap tabular-nums">미팅 {Number(data.meetings || 0)}</span>
      </span>
    </MiniRow>
  );
}

// ── 계약 (chevron 월 nav, 건수·장수) ──────────────────────────────────────────
// 큰 숫자 (text-2xl emerald) + "건" 작게 + 장수 작게. watermark: FileSignature.
export function MyContractsMonthMini({ data, month, onMonthChange, accentOverride, sortableId, onClick }) {
  const baseProps = {
    icon: FileSignature,
    label: '계약',
    accent: 'emerald',
    accentOverride,
    monthNavigate: true,
    month,
    onMonthChange,
    sortableId,
    size: 'S',
    watermarkIcon: FileSignature,
    onClick,
  };
  if (!data) return <MiniRow {...baseProps} loading width="wide" />;
  if (!data.allowed) return <MiniRow {...baseProps} denied width="wide" />;
  return (
    <MiniRow {...baseProps} width="wide">
      <span className="flex flex-col items-end gap-1">
        <span className="inline-flex items-baseline gap-1">
          <span className="text-2xl font-black tabular-nums leading-none text-emerald-700 dark:text-emerald-300">{Number(data.contractCount || 0)}</span>
          <span className="text-[11px] font-semibold text-[var(--text-sub)]">건</span>
        </span>
        <span className="text-[11px] font-semibold text-[var(--text-sub)] whitespace-nowrap tabular-nums">{Number(data.ticketCount || 0)}장</span>
      </span>
    </MiniRow>
  );
}
